import SafeHtml from './SafeHtml.jsx'

export default function RecapSection({ label, color, items }) {
  const cfg = {
    green: { bg: 'bg-green-500/15', border: 'border-green-500/30', text: 'text-green-300', dot: '🟢' },
    amber: { bg: 'bg-amber-500/15', border: 'border-amber-500/30', text: 'text-amber-300', dot: '🟡' },
    red:   { bg: 'bg-red-500/15',   border: 'border-red-500/30',   text: 'text-red-300',   dot: '🔴' },
  }[color]
  return (
    <div className={`${cfg.bg} border ${cfg.border} rounded-xl p-3`}>
      <p className={`${cfg.text} text-xs font-semibold mb-2`}>{cfg.dot} {label} ({items.length})</p>
      <ul className="space-y-1.5">
        {items.map((item, i) => (
          <li key={i} className="text-white text-xs leading-snug">
            • <SafeHtml html={item.enonce} />
            {item.bonne_reponse && (
              <span className="text-white/40 block ml-3 mt-0.5">→ <SafeHtml html={item.bonne_reponse} /></span>
            )}
          </li>
        ))}
      </ul>
    </div>
  )
}
